export function getCachedEdgebetFilters() {
  try {
    let lowRisk = localStorage.getItem('edgebet_lowRisk')
    lowRisk = lowRisk === undefined ? 0 : +lowRisk
    let recommendedLeagues = localStorage.getItem('edgebet_recommendedLeagues')
    recommendedLeagues = recommendedLeagues === undefined ? 0 : +recommendedLeagues
    let next12hours = localStorage.getItem('edgebet_next12hours')
    next12hours = next12hours === undefined ? 0 : +next12hours
    let bookmakerList = localStorage.getItem('edgebet_bookmakerList')
    let sound = JSON.parse(localStorage.getItem('edgebet_sound'))
    sound = sound === undefined ? false : sound
    return {
      lowRisk,
      recommendedLeagues,
      next12hours,
      bookmakerList,
      sound
    }
  } catch (e) {
    return {
      lowRisk: true,
      recommendedLeagues: true,
      next12hours: true,
      bookmakerList: 0,
      sound: false
    }
  }
}

export function saveEdgebetFilterInCache(key, value) {
  try {
    localStorage.setItem(`edgebet_${key}`, value)
  } catch (e) {}
}

export function getHiddenEdges() {
  let hiddenEdges = localStorage.getItem('edgebet_hiddenEdges')
  if (!hiddenEdges)
    return []
  return JSON.parse(hiddenEdges)
}

export function hideEdge(edgeid) {
  let hiddenEdges = getHiddenEdges()
  hiddenEdges.push(edgeid)
  localStorage.setItem('edgebet_hiddenEdges', JSON.stringify(hiddenEdges))
  return hiddenEdges
}

export function clearHiddenEdges() {
  localStorage.removeItem('edgebet_hiddenEdges')
  return []
}



/** WEBPACK FOOTER **
 ** ./src/utils/cache.js
 **/